import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import usePartnerAuth from 'hooks/usePartnerAuth';
import Loader from 'components/Loader';

// ==============================|| AUTH GUARD — require partner login ||============================== //

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitializing } = usePartnerAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isInitializing && !isAuthenticated) {
      navigate('/login', { replace: true });
    }
  }, [isAuthenticated, isInitializing, navigate]);

  if (isInitializing || !isAuthenticated) return <Loader />;

  return children;
}

AuthGuard.propTypes = { children: PropTypes.node };
